import type { CSSProperties } from 'react';

interface Props {
  /** Path to an SVG asset under /public. */
  src: string;
  className?: string;
}

/**
 * Renders an SVG asset as a solid `currentColor` silhouette via CSS mask.
 * Plain `<img>` icons keep their baked-in fill, so a dark-filled glyph
 * vanishes on the dark opera surfaces. Masking lets the icon inherit the
 * themed text colour (`--ink`) and stay legible in every style mode.
 */
export default function MaskIcon({ src, className = '' }: Props) {
  const style: CSSProperties = {
    display: 'inline-block',
    backgroundColor: 'currentColor',
    WebkitMaskImage: `url(${src})`,
    maskImage: `url(${src})`,
    WebkitMaskRepeat: 'no-repeat',
    maskRepeat: 'no-repeat',
    WebkitMaskSize: 'contain',
    maskSize: 'contain',
    WebkitMaskPosition: 'center',
    maskPosition: 'center',
  };
  return <span aria-hidden="true" className={className} style={style} />;
}
